import loadScript from 'utils/loadScript'

const PADDLE_VENDOR_ID = process.env.PADDLE_VENDOR_ID
const PADDLE_JS_SRC = 'https://cdn.paddle.com/paddle/paddle.js'
const PADDLE_NAME = 'Paddle'

const loadPaddle = () =>
  loadScript(PADDLE_JS_SRC, PADDLE_NAME).then(Paddle => {
    Paddle.Setup({ vendor: parseInt(PADDLE_VENDOR_ID) })
    return Paddle
  })

export default loadPaddle
